WebFont.load({
    custom: {
        urls: ['https://fonts.googleapis.com/css?family=Lato:300i|Quicksand:300,400,500,700&amp;subset=latin-ext&display=swap']
    }
});

var scripts = {
    lazy: null,
    globalVars:{
        digitShownClass: 'is-shown',
        vivusTriggerClass: 'vivus-wait-for-trigger'
    },

    init: function () {
        var self = this;
        this.showEmails(); // musi być przed svg4everybody bo przy linkach mailto używamy svgów
        this.svg4everybody();
        this.abananaFooter();
        this.lazyLoadImages();
        this.countersSlider();
        this.awardsSlider();
        this.loadMoreRealizations();
        this.realizationDetailsStickyElements();
        this.contactMap();
        this.howDoWeWorkSlider();
        this.dictionaryNavigation();
        this.cookieInfo();
        this.bodyClass();
        this.showHistory();
        this.initPhotoswipe();
        this.newsletterSignup();
        this.newsletterDeactivate();
        this.videoPopover();
        this.qualityLastBoxGradient();

        document.addEventListener('svg-sprite-loaded', function () {
            self.scrollAnimations();
        });
    },


    svg4everybody: function () {
        svg4everybody({
            // ładuje content svgów, w miejscu ich występowania dla każdej przeglądarki,
            // dzięki temu mamy możliwość manipulacji DOMem
            polyfill: true
        });

        // pobieram 1-szy svg i sprawdzam w petli czy został już załadowany,
        // jeśli tak, to rozgłaszam event svg-sprite-loaded
        var svg = document.querySelector('.svg-sprite');
        var interval = setInterval(check, 500);

        check();

        function check() {
            if(svg.childElementCount > 0) {
                clearInterval(interval);

                var event = document.createEvent('Event');
                event.initEvent('svg-sprite-loaded', true, true);
                document.dispatchEvent(event);
            }
        }
    },

    /**
     * Operacje na banerze abananowym w stopce
     */
    abananaFooter: function () {
        var el = document.getElementById('abanana-footer'),
            footer = document.getElementById('footer');

        // tylko na stronie głównej
        if (el === null || !headerMenu.isHomePage()) return false;

        var setPosition = function () {
            var st = window.pageYOffset,
                stickyClass = 'sticky';

            if (st > footer.offsetTop - window.innerHeight) {
                addClass(el, stickyClass);
            } else {
                removeClass(el, stickyClass);
            }
        };

        window.addEventListener('scroll', setPosition);
        window.addEventListener('load', setPosition);
    },

    /**
     * Lazy loading obrazków
     */
    lazyLoadImages: function () {
        this.lazy = new LazyLoad({
            elements_selector: ".lazy",
            threshold: 400,
            callback_enter: function (el) {
                if (hasClass(el, 'lazy-bg')) {
                    addClass(el, 'lazy-bg-visible');
                }
            },
            callback_load: function (el) {
                AOS.refresh();

                if (hasClass(el, 'lazy-with-loader')) {
                    var parent = el.closest('.picture-with-loader');
                    if (parent){
                        addClass(parent, 'loaded');
                    }
                }
            }
        });
    },

    /**
     * Slider z licznikami na stronie głównej
     * todo-kt: zweryfikowac slider na mobile bo w devtoolsach sie rozjezdza
     */
    countersSlider: function () {
        var perPageConf = {},
            el = document.getElementById('counters-slider'),
            countersSlider,
            eventsAttached = false;

        if (el === null) return;

        perPageConf[breakpoints.sm] = 2;
        perPageConf[breakpoints.md] = 3;

        function initSlider() {
            countersSlider = new Siema({
                selector: el.querySelector('.items'),
                perPage: perPageConf,
                onInit: hideNavigationButtons,
                onChange: hideNavigationButtons,
            });

            function hideNavigationButtons(slider) {
                var prev = el.querySelector('.navigation .nav-btn.prev'),
                    next = el.querySelector('.navigation .nav-btn.next'),
                    hiddenClass = 'hidden';

                slider = (typeof slider !== 'undefined') ? slider : this;

                if (slider.currentSlide > 0) {
                    removeClass(prev, hiddenClass);
                } else {
                    addClass(prev, hiddenClass);
                }

                if (slider.currentSlide + slider.perPage < slider.innerElements.length) {
                    removeClass(next, hiddenClass);
                } else {
                    addClass(next, hiddenClass);
                }
            }

            var resizeHandler = function () {
                hideNavigationButtons(countersSlider);
            };

            countersSlider.throttledResizeHandler = throttle(resizeHandler, 100);
            window.addEventListener('resize', countersSlider.throttledResizeHandler);

            if (!eventsAttached) {
                el.querySelectorAll('.navigation .nav-btn').forEach(function (item) {
                    item.addEventListener('click', function () {
                        if (hasClass(item, 'prev')) countersSlider.prev();
                        if (hasClass(item, 'next')) countersSlider.next();
                    });
                });

                eventsAttached = true;
            }
        }


        if (!breakpoints.match(breakpoints.lg)) {
            initSlider();
        }

        // wykrywanie przejścia przez breakpoint lg
        breakpoints.addListener(breakpoints.lg, function () {
            if (breakpoints.match(breakpoints.lg)) {
                if (countersSlider !== null) {
                    countersSlider.destroy(true);
                    window.removeEventListener('resize', countersSlider.throttledResizeHandler);
                }
            } else {
                initSlider();
                //todo-kt: na mobile w devtoolsach slider przyjmuje niewlasciwą szerokosc
            }
        });
    },

    /**
     * Animuje liczby na liczniku
     * todo-kt: animacja liczba na sliderze dopiero po przejsciu do slajdu
     */
    counterAnimate: function (el) {
        var self = this,
            flippingClass = 'flipping',
            num = el.getAttribute('data-num'),
            val = 0,
            elIndex = index(el),
            siblingsCount = el.parentNode.childElementCount,
            increment = siblingsCount - elIndex + 1;

        flipTo(val, num);

        function flipTo(current, end) {
            var val = parseInt(current),
                num = val + increment;

            end = parseInt(end);
            num = num > end ? end : num;

            if(val === end) return;

            if(isIE()) {
                num = end;
                val = num;
            }

            //num = end; // ustawia końcową wartość w 1-szym przebiegu

            el.innerHTML = '<span class="base">' + val + '</span>' +
                '<div class="flap over front" data-content="' + val + '"></div>' +
                '<div class="flap over back" data-content="' + num + '"></div>' +
                '<div class="flap under" data-content="' + num + '"></div>';

            addClass(el, flippingClass);
            addClass(el, self.globalVars.digitShownClass);

            var delay = num/end,
                // ((old_value - old_min) / (old_max - old_min)) * (new_max - new_min) + new_min
                normalizedDelay = ((delay - 1/end) / (1 - 1/end)) * (400 - 250) + 250;

            setTimeout(function () {
                el.querySelector('.base').innerHTML = num;
                removeClass(el, flippingClass);

                flipTo(num, end);
            }, normalizedDelay);
        }
    },

    /**
     * Slider z nagrodami
     */
    awardsSlider: function () {
        var perPageConf = {},
            el = document.getElementById('awards-slider'),
            self = this;

        if (el === null) return;

        perPageConf[breakpoints.sm] = 2;
        perPageConf[breakpoints.lg] = 3;

        var awardsSlider = new Siema({
            selector: el.querySelector('.items'),
            perPage: perPageConf,
            loop: true,
            onInit: function () {
                this.selector.querySelectorAll('.lazy').forEach(function (item) {
                    self.lazy.load(item);
                });
            }
        });

        el.querySelectorAll('.navigation .nav-btn').forEach(function (item) {
            item.addEventListener('click', function () {
                if (hasClass(item, 'prev')) awardsSlider.prev();
                if (hasClass(item, 'next')) awardsSlider.next();
            });
        });
    },

    /**
     * Przycisk, który ładuje pozostałe realizacje - po kliknięciu realizacje ładuję się automatycznie przy scrollu
     */
    loadMoreRealizations: function () {
        var el = document.getElementById('load-more-realizations'),
            container = document.getElementById('realizations-container'),
            self = this;
        if (el === null) return;

        var total = parseInt(el.getAttribute('data-total')),
            btn = el.querySelector('.btn');

        function getData() {
            var xhr = new XMLHttpRequest(),
                loadingClass = 'loading';

            addClass(el, loadingClass);
            xhr.open('POST', el.getAttribute('data-url'), true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            var data = {
                offset: parseInt(el.getAttribute('data-offset'))
            };

            xhr.onload = function () {
                if (xhr.status === 200) {
                    var resp = JSON.parse(xhr.responseText);
                    container.innerHTML = container.innerHTML + resp.html;
                    el.setAttribute('data-offset', resp.offset);
                    removeClass(el, loadingClass);
                    self.lazy.update();

                    if (isIE() || isIOS()) {
                        AOS.refreshHard();
                    }

                    if (resp.offset >= total) {
                        addClass(el, 'finito');
                        window.removeEventListener('scroll', throttledScrollHandler);
                    }
                }
            };

            xhr.send(encodeObject(data));
        }

        function clickHandler() {
            addClass(el, 'hidden-btn');
            btn.removeEventListener('click', clickHandler);
            getData();

            window.addEventListener('scroll', throttledScrollHandler);
        }

        btn.addEventListener('click', clickHandler);

        var throttledScrollHandler = throttle(scrollHandler, 100);

        function scrollHandler() {
            if (isElementInViewport(el) && !hasClass(el, 'loading')) {
                getData();
            }
        }
    },

    /**
     * Ustawia sticky description na odpowiedniej wysokości, tak żeby:
     * - przypiął się do dolnej krawędzi ekranu, kiedy jego wysokość jest większa od wysokości ekranu
     * - przypiął się do górnej krawędzi ekraniu, kiedy jego wysokość jest mniejsza od wysokości ekranu
     *
     * Ustawia sticky title
     */
    realizationDetailsStickyElements: function () {
        var stickyDescription = document.getElementById('sticky-description'),
            stickyTitle = document.querySelector('.page.page-realizations-details .page-title');

        if (stickyDescription === null && stickyTitle === null) return;

        function setTop() {
            if (!breakpoints.match(breakpoints.lg)) {
                stickyDescription.style.top = null;
                return false;
            }

            var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            if (stickyDescription.offsetHeight > windowHeight) {
                stickyDescription.style.top = 'calc(100vh - ' + (stickyDescription.offsetHeight) + 'px)';
            } else {
                stickyDescription.style.top = null;
            }
        }

        window.addEventListener('resize', rafThrottle(setTop));
        window.addEventListener('load', function() {
            setTimeout(function () {
                setTop();
            }, 50);
        });

        var stickyTitleH1 = stickyTitle.querySelector('h1'),
            lastDy = 0,
            stickyMenuHiddenClass = 'sticky-menu-hidden';

        function scrollHandle() {
            var offsetTop = stickyTitle.firstElementChild.offsetTop,
                dY = window.pageYOffset - offsetTop;

            if (breakpoints.match(breakpoints.lg)) {
                dY = dY - 40;
            }

            if (dY < 0) {
                dY = 0;
            } else if (dY > offsetTop) {
                dY = offsetTop;
            }

            if (dY !== lastDy) {
                stickyTitleH1.style.transform = 'translate(0,' + dY + 'px)';
            }

            if (hasClass(headerMenu.header, headerMenu.stickyHiddenClass)) {
                addClass(stickyTitle, stickyMenuHiddenClass);
            } else {
                removeClass(stickyTitle, stickyMenuHiddenClass);
            }

            lastDy = dY;
        }

        window.addEventListener('scroll', rafThrottle(scrollHandle));
        window.addEventListener('resize', rafThrottle(scrollHandle));
    },

    /**
     * Uaktywnia linki z mailem - teoretycznie w minimalnym stopniu zabezpiecza przed robotami spamerskimi
     */
    showEmails: function () {
        var elements = document.querySelectorAll('.email-link');

        if (elements === null) return;

        elements.forEach(function (el) {
            var email = el.getAttribute('data-a') + '@' + el.getAttribute('data-b');
            el.setAttribute('href', "mailto:" + email);

            if (hasClass(el, 'replace-at')) {
                email = '';
                el.innerHTML = el.innerHTML.replace('[at]', '@');
            }

            el.innerHTML = el.innerHTML + email;
        });
    },

    /**
     * Załadowanie Google mapy na stronie Kontakt
     */
    contactMap: function () {
        var el = document.getElementById('contact-map');

        if (el === null) return;

        var eura7 = {lat: 50.0748879, lng: 20.007813};

        var styledMapType = new google.maps.StyledMapType(
            [
                {
                    "featureType": "poi",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                }
            ],
            {name: 'Styled Map'});

        var map = new google.maps.Map(el, {
            zoom: 17,
            center: eura7
        });

        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');


        new google.maps.Marker({
            position: eura7,
            map: map,
            title: 'Hello World!'
        });
    },

    howDoWeWorkSlider: function () {
        var el = document.getElementById('how-do-we-work-slider'),
            slider,
            eventsAttached = false,
            classActive = 'active',
            classInactive = 'inactive',
            classVivus = this.globalVars.vivusTriggerClass;

        if (el === null) return;


        function init() {
            var heights = [];

            slider = new Siema({
                selector: el.querySelector('.stages'),
                draggable: false,
                onChange: function () {
                    removeClass(el.querySelector('.top-navigation .nav-btn.' + classActive), classActive);
                    addClass(el.querySelector('.top-navigation .nav-btn[data-index="' + this.currentSlide + '"]'), classActive);

                    removeClass(el.querySelector('.bottom-navigation .nav-btn.' + classInactive), classInactive);
                    if (this.currentSlide === 0) addClass(el.querySelector('.bottom-navigation .nav-btn.prev'), classInactive);
                    if (this.currentSlide === this.innerElements.length - 1) addClass(el.querySelector('.bottom-navigation .nav-btn.next'), classInactive);

                    this.selector.style.maxHeight = heights[this.currentSlide] + 'px';

                    // Rysowanie svga
                    var svgSprite = el.querySelector('.stage-' + this.currentSlide + ' .svg-sprite.' + classVivus);
                    if(svgSprite) {
                        removeClass(svgSprite, classVivus);
                        AOS.refreshHard();
                    }
                },
                onInit: function () {
                    this.innerElements.forEach(function (item) {
                        heights.push(item.offsetHeight);
                    });

                    this.selector.style.maxHeight = heights[0] + 'px';
                }
            });

            if (!eventsAttached) {
                el.querySelectorAll('.bottom-navigation .nav-btn').forEach(function (item) {
                    item.addEventListener('click', function () {
                        if (hasClass(item, 'prev')) slider.prev();
                        if (hasClass(item, 'next')) slider.next();
                    });
                });

                el.querySelectorAll('.top-navigation .nav-btn').forEach(function (item) {
                    item.addEventListener('click', function () {
                        slider.goTo(item.getAttribute('data-index'));
                    });
                });

                eventsAttached = true;
            }
        }

        window.addEventListener('load', function () {
            if (breakpoints.match(breakpoints.lg)) {
                init();
            }

            breakpoints.addListener(breakpoints.lg, function () {
                if (breakpoints.match(breakpoints.lg)) {
                    init();
                } else {
                    if (slider !== null) slider.destroy(true);
                }
            });
        });
    },

    dictionaryNavigation: function () {
        var el = document.getElementById('dictionary-list'),
            dictionaryNav = document.getElementById('dictionary-nav'),
            body = document.querySelector('body'),
            classActive = 'active',
            classOpenedMenu = 'opened-dictionary-nav';

        if (el === null) return;

        document.getElementById('dictionary-nav-open').addEventListener('click', openNav);
        document.getElementById('dictionary-nav-close').addEventListener('click', closeNav);

        function openNav() {
            addClass(dictionaryNav, classActive);
            addClass(body, classOpenedMenu);
        }

        function closeNav() {
            removeClass(dictionaryNav, classActive);
            removeClass(body, classOpenedMenu);
        }

        el.querySelectorAll('.letter-link:not(.disabled)').forEach(function (item) {
            item.addEventListener('click', function () {
                var id = 'list-for-' + this.innerHTML.trim(),
                    bAddClass = !hasClass(item, classActive);
                removeClass(el.querySelector('.letter-link.' + classActive), classActive);
                removeClass(el.querySelector('.li-list.' + classActive), classActive);


                if (bAddClass) {
                    addClass(item, classActive);
                    addClass(document.getElementById(id), classActive);
                }
            });
        });
    },

    /**
     * Obsługuje komunikat o cookies
     */
    cookieInfo: function () {
        var el = document.getElementById('cookie-info-layer'),
            visibleClass = 'is-visible';

        if (el === null) return false;

        function showCookieInfoLayer() {
            if (Cookies.get('cookie_info') !== 'set') {
                setTimeout(function () {
                    addClass(el, visibleClass);
                }, 10000);
            }
        }

        showCookieInfoLayer();

        document.getElementById('cookie-info-accept').addEventListener('click', function () {
            Cookies.set('cookie_info', 'set', {expires: 365, path: '/'});
            removeClass(el, visibleClass);
        });
    },

    /**
     * Animacje wyzwalane podczas scrollowania strony:
     * - AOS, który wyświetla elementy
     * - Vivus, który rysuje svgi
     */
    scrollAnimations: function () {
        var self = this,
            animationStartedClass = 'animation-started';

        document.addEventListener('aos:in:count', function (e) {
            var detail = e.detail;
            if(typeof detail !== 'undefined' && typeof detail.tagName === 'undefined'){
                detail = detail.detail;
            }

            var delay = parseInt(detail.getAttribute('data-aos-delay'));
            delay = delay ? delay : 0;

            var i = 0;
            var digits = Array.prototype.slice.call(detail.querySelectorAll('.digit'));

            digits.reverse().forEach(function (item) {
                if(!hasClass(item, self.globalVars.digitShownClass)) {
                    setTimeout(function () {
                        self.counterAnimate(item);
                    }, delay + i * 150);

                    i++;
                }
            });


        });

        document.addEventListener('aos:in:aos-svg-animate', function (e) {
            var detail = e.detail;
            if(typeof detail !== 'undefined' && typeof detail.tagName === 'undefined'){
                detail = detail.detail;
            }
            //todo-kt: rysowanie ikon w IE nie działa w EDGE strasznie wolno leci

            var el = detail.querySelector('.svg-sprite'),
                delay = detail.getAttribute('data-aos-delay') ? detail.getAttribute('data-aos-delay') : 0;

            if (hasClass(el, animationStartedClass)) return;

            setTimeout(function () {
                startAnimation(el);
            }, delay);
        });

        AOS.init({
            duration: 800,
            once: true,
            offset: 120,
            //disable: 'mobile'
        });

        /*if(isIE()) {
            // refresh AOSa na IE bo nie zawsze pojawia się content
            window.addEventListener('load', function () {
                setTimeout(function () {
                    AOS.refresh();
                }, 1000)
            });
        }*/

        var vivusOptions = {
            type: 'delayed',
            start: 'manual',
            duration: 100,
            pathTimingFunction: Vivus.EASE,
            dashGap: 20
        };

        function startAnimation(el) {
            if(isIE()) {
                addClass(el, animationStartedClass);
                setTimeout(function () {
                    addClass(el, 'animation-ended');
                }, 5000);
                return;
            }

            if (breakpoints.match(breakpoints.lg)) {
                var v = new Vivus(el, vivusOptions);
                
                if(!hasClass(el, self.globalVars.vivusTriggerClass)) {
                    v.play(function () {
                        setTimeout(function () {
                            addClass(el, 'animation-ended');
                        }, 2000);
                    });

                    addClass(el, animationStartedClass);
                }
            } else {
                addClass(el, animationStartedClass);
            }
        }


        /*window.addEventListener('load', function () {
            document.querySelectorAll('.aos-animate').forEach(function (item) {
                var el = item.querySelector('.svg-sprite.animated');

                if (el === null) return;

                var delay = item.getAttribute('data-aos-delay') ? item.getAttribute('data-aos-delay') - 150 : 0;

                setTimeout(function () {
                    startAnimation(el);
                }, delay);
            });
        });*/
    },

    bodyClass: function () {
        var body = document.querySelector('body');

        if (isIE()) {
            addClass(body, 'ie');
        }

        if (isIOS()) {
            addClass(body, 'ios');
        }
    },

    /**
     * Pokazuje pozostałe elementy z historii po kliknięciu w przyciskna mobileu
     */
    showHistory: function () {
        var el = document.getElementById('history-show-more-btn'),
            hiddenClass = 'mobile-hidden';
        if (el === null) return;

        el.addEventListener('click', function () {
            document.querySelectorAll('.history .item.' + hiddenClass).forEach(function (item) {
                removeClass(item, hiddenClass);
            });

            addClass(el.parentElement, hiddenClass);
        });
    },

    initPhotoswipe: function () {
        var galleriesSelector = '.pswp-gallery';
        initPhotoSwipeFromDOM(galleriesSelector);
    },

    newsletterSignup: function () {
        var el = document.getElementById('newsletter-signup');
            
        if (el === null) return;
        
        var triggerEl = document.getElementById('newsletter-signup-trigger'),
            triggerElWrapper = document.getElementById('newsletter-signup-trigger-wrapper'),
            body = document.querySelector('body'),
            isActiveClass = 'is-active',
            darkClass = 'dark',
            bodyOpenedNewsletterClass = 'opened-newsletter-signup';

        // pokazuje/chowa box z newsletterem
        var showOrHide = function (e) {
            e.preventDefault();
            if(hasClass(el, isActiveClass )) {
                removeClass(el, isActiveClass);
                removeClass(body, bodyOpenedNewsletterClass);
            } else {
                addClass(el, isActiveClass);
                addClass(body, bodyOpenedNewsletterClass);
            }
        };

        triggerEl.addEventListener('click', showOrHide);
        document.getElementById('newsletter-signup-footer-button').addEventListener('click', showOrHide);

        // Koryguje pozycję dziubka do otwierania boxa z newsletterem
        var triggerPosition = function () {
            if (breakpoints.match(breakpoints.lg)) {
                var y = el.offsetTop,
                    threshold = 150;

                if(y < threshold){
                    triggerElWrapper.style.transform = 'translate(0, ' + (threshold - y) + 'px)';
                } else {
                    triggerElWrapper.removeAttribute('style');
                }

                addClass(triggerEl, 'is-ready');
            } else {
                triggerElWrapper.removeAttribute('style');
            }
        };

        var rafTriggerPosition = rafThrottle(triggerPosition);
        window.addEventListener('resize', rafTriggerPosition);
        window.addEventListener('load', triggerPosition);

        window.addEventListener('scroll', function () {
            if(window.pageYOffset > headerMenu.stickyThreshold()) {
                addClass(el, darkClass);
            } else {
                removeClass(el, darkClass);
            }
        });

        // usuwa transition przy przejściu przez breakpoint
        breakpoints.addListener(breakpoints.lg, function () {
           addClass(el, 'no-transition');
           setTimeout(function () {
               removeClass(el, 'no-transition');
           }, 100);
        });

        (function () {
            // Walidacja formularza
            var form = document.getElementById("newsletter-signup-form");

            if (form === null) return;


            var errorBox = document.getElementById('newsletter-signup-error-msg'),
                newsletterEmailField = document.getElementById('newsletter_email'),
                errorClass = 'error',
                submittingClass = 'is-submitting',
                restartLoaderClass = 'restart-loader',
                attributes;

            var constraints = {
                newsletter_email: {
                    myEmailValidator: true
                }
            };

            var options = {
                fullMessages: false
            };


            form.addEventListener("submit", function(e) {
                e.preventDefault();
                if(hasClass(form, submittingClass)) return false;

                clearErrorMsg();

                addClass(form, submittingClass);
                removeClass(form, restartLoaderClass);

                attributes = {
                    newsletter_email: newsletterEmailField.value,
                    newsletter_name: document.getElementById('newsletter_name').value,
                };

                validate.async(attributes, constraints, options).then(validationSuccess, validationError);
            });

            var validationSuccess = function () {

                var xhr = new XMLHttpRequest();
                xhr.open('POST', '/newsletter/add', true);
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

                xhr.onload = function() {
                    if (xhr.status >= 200 && xhr.status < 400) {
                        // Success!
                        var data = JSON.parse(xhr.responseText);
                        if(data.status === 'OK') {
                            clearErrorMsg();

                            removeClass(el, 'show-box-1');
                            addClass(el, 'show-box-2');
                        } else {
                            setErrorMsg(jsLang.LANG_FORM_SERVER_ERROR);
                        }
                    } else {
                        setErrorMsg(jsLang.LANG_FORM_SERVER_ERROR);
                    }
                };

                xhr.onerror = function() {
                    // Connection error
                    setErrorMsg(jsLang.LANG_FORM_SERVER_ERROR);
                };

                xhr.send(serialize(attributes));
            };

            var validationError = function(errors) {
                setErrorMsg(errors);
            };

            var setErrorMsg = function(msg){
                removeClass(newsletterEmailField, errorClass);

                if(typeof msg === 'object'){
                    msg = msg.newsletter_email;
                    addClass(newsletterEmailField, errorClass);
                }

                errorBox.innerHTML = msg;
                removeClass(form, submittingClass);
                restartLoader();
            };

            var clearErrorMsg = function(){
                errorBox.innerHTML = '';
                removeClass(newsletterEmailField, errorClass);
                removeClass(form, submittingClass);
            };

            var restartLoader = function(){
                setTimeout(function () {
                    addClass(form, restartLoaderClass);
                }, 300);
            };

            validate.validators.myEmailValidator = function(value) {
                return new validate.Promise(function(resolve, reject) {
                    var badEmailErrors = validate.single(value, {presence: true, email: true});

                    if(badEmailErrors){
                        return resolve(jsLang.LANG_FORM_EMAIL);
                    }

                    var xhr = new XMLHttpRequest();
                    xhr.open('POST', '/newsletter/check', true);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

                    xhr.onload = function() {
                        if (xhr.status >= 200 && xhr.status < 400) {
                            // Success!
                            var data = JSON.parse(xhr.responseText);
                            if(data === true) {
                                resolve();
                            } else {
                                resolve(data);
                            }
                        } else {
                            // Error
                            reject(jsLang.LANG_FORM_SERVER_ERROR);
                        }
                    };

                    xhr.onerror = function() {
                        // Connection error
                        reject(jsLang.LANG_FORM_SERVER_ERROR);
                    };

                    xhr.send('newsletter_email=' + encodeURIComponent(value));
                });
            };
        })();
    },
    newsletterDeactivate: function () {
        var form = document.getElementById("newsletter-deactivate-form");

        if (form === null) return;


        var errorBox = document.getElementById('newsletter-deactivate-error-msg'),
            newsletterEmailField = document.getElementById('newsletter_email'),
            errorClass = 'error',
            submittingClass = 'is-submitting',
            restartLoaderClass = 'restart-loader';

        var constraints = {
            deactivation_reason: {
                presence: {
                    message: jsLang.LANG_NEWSLETTER_DEACTIVATE_PAGE_FORM_ERROR_NO_OPTION_SLECTED
                }
            },
            deactivation_text_reason: {
                format: function (value, attributes) {
                    if(attributes.deactivation_reason === "3"){
                        return {
                            pattern: /(\s*\S+\s*)+/g, // nie przepuszczamy tekstu składającego się z samych białych znaków
                            message: jsLang.LANG_NEWSLETTER_DEACTIVATE_PAGE_FORM_ERROR_NO_REASON
                        };
                    } else {
                        return null;
                    }
                },

                presence: function (value, attributes) {
                    if(attributes.deactivation_reason === "3"){
                        return {
                            message: jsLang.LANG_NEWSLETTER_DEACTIVATE_PAGE_FORM_ERROR_NO_REASON
                        };
                    } else {
                        return null;
                    }
                },
            },
        };

        var options = {
            fullMessages: false
        };

        form.addEventListener("submit", function(e) {
            e.preventDefault();
            if(hasClass(form, submittingClass)) return false;

            clearErrorMsg();

            addClass(form, submittingClass);
            removeClass(form, restartLoaderClass);

            var errors = validate(form, constraints, options);


            if(errors) {
                validationError(errors);
            } else {
                validationSuccess();
            }
        });

        var validationSuccess = function () {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', form.getAttribute('action'), true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            //xhr.setRequestHeader('Content-Type', 'multipart/form-data; charset=UTF-8');

            xhr.onload = function() {
                if (xhr.status >= 200 && xhr.status < 400) {
                    // Success!
                    var data = JSON.parse(xhr.responseText);
                    if(data.status === 'OK') {
                        addClass(form, 'show-confirmation');
                    } else {
                        setErrorMsg(data.error);
                    }
                } else {
                    setErrorMsg(jsLang.LANG_FORM_SERVER_ERROR);
                }
            };

            xhr.onerror = function() {
                // Connection error
                setErrorMsg(jsLang.LANG_FORM_SERVER_ERROR);
            };

            xhr.send(new FormData(form));
        };

        var validationError = function(errors) {
            setErrorMsg(errors);
        };

        var setErrorMsg = function(msg){
            removeClass(newsletterEmailField, errorClass);

            if(typeof msg === 'object'){
                msg = msg.deactivation_reason || msg.deactivation_text_reason;
                //addClass(newsletterEmailField, errorClass);
            }

            errorBox.innerHTML = msg;
            removeClass(form, submittingClass);
            restartLoader();
        };

        var clearErrorMsg = function(){
            errorBox.innerHTML = '';
            removeClass(newsletterEmailField, errorClass);
            removeClass(form, submittingClass);
        };

        var restartLoader = function(){
            setTimeout(function () {
                addClass(form, restartLoaderClass);
            }, 300);
        };
    },

    /**
     * Obsługa popovera po kliknięciu w link z filmem z YT
     */
    videoPopover: function () {
        var videoWrapperEl = document.getElementById('video-popover-wrapper'),
            videoWrapperActiveClass = 'active',
            iframeLoadedClass = 'iframe-loaded',
            restartLoaderAnimationClass = 'restart-loader-animation';

        if (videoWrapperEl === null) return;

        var tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        document.addEventListener('click', function (e) {
            if(!hasClass(e.target, 'video-popover')) {
                return false;
            }

            e.preventDefault();

            var item = e.target;

            if (videoWrapperEl === null) return;

            addClass(videoWrapperEl, videoWrapperActiveClass);
            removeClass(videoWrapperEl, restartLoaderAnimationClass);

            var player = new YT.Player('video-popover-iframe', {
                //height: '1080',
                //width: '1920',
                videoId: item.getAttribute('data-yt-id'),
                playerVars: {
                    'autoplay': 1,
                    'rel': 0
                },
                events: {
                    'onReady': function (event) {
                        addClass(videoWrapperEl, iframeLoadedClass);
                    },
                    'onStateChange': function (event) {
                        if(event.data === YT.PlayerState.ENDED){
                            player.stopVideo();
                        }
                        // do nothing
                    }
                }
            });

            var clickHandler = function () {
                close();
            };

            videoWrapperEl.addEventListener('click', clickHandler);

            var keydownHandler = function (e) {
                if (e.keyCode === 27) { // Esc
                    close();
                }
            };

            document.addEventListener('keydown', keydownHandler);

            var close = function () {
                removeClass(videoWrapperEl, videoWrapperActiveClass);
                removeClass(videoWrapperEl, iframeLoadedClass);

                setTimeout(function () {
                    addClass(videoWrapperEl, restartLoaderAnimationClass);
                }, 300);

                player.destroy();
                document.removeEventListener('keydown', keydownHandler);
                videoWrapperEl.removeEventListener('click', clickHandler);

            };
        });
    },

    /**
     * Obsługa gradientu przy hoverze dla ostatniego boxa na stronie "Jakość"
     */
    qualityLastBoxGradient: function () {
        var box = document.getElementById('quality-last-box-wrapper');

        if (box === null) return;

        var max = 90,
            min = 10;

        var mouseMoveHandler = throttle(function () {
            var e = arguments[0];

            var rect = box.getBoundingClientRect();

            var x = 100 - Math.round((e.clientX - rect.left) / rect.width * 100);
            var y = 100 - Math.round((e.clientY - rect.top) / rect.height * 100);
            
            x = Math.max(min, Math.min(max, x));
            y = Math.max(min, Math.min(max, y));

            box.style.backgroundPosition = x + '% ' + y + '%';
        }, 50);

        box.addEventListener('mousemove', mouseMoveHandler);
    },
};

ready(function () {
    //console.log('Hello World!');

    scripts.init();
    headerMenu.init();
    homeSlider.init();
});